import 'jquery-inview';
import landing from './templateLandingPage';

export default {
  init() {
    landing.parallaxImage();
    landing.slider();
    landing.appendUTMQueryParamsToCtas();
    landing.playVideoOnScroll();
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/templateAboutUs.js